import { Component, Input } from '@angular/core';

export interface ActivityMetricsSummaryCard {
  label: string;
  value: string | number;
  helper: string;
}

@Component({
  selector: 'app-agent-performance-activity-metrics-summary-widget',
  templateUrl: './agent-performance-activity-metrics-summary-widget.component.html',
  styleUrls: ['./agent-performance-activity-metrics-summary-widget.component.scss']
})
export class AgentPerformanceActivityMetricsSummaryWidgetComponent {
  @Input() cards: ActivityMetricsSummaryCard[] = [];
  @Input() widget_title = 'Summary';
  @Input() widget_size: 'full' | 'abstract' | 'side' = 'full';

  trackByLabel(index: number, card: ActivityMetricsSummaryCard): string {
    return `${index}:${card.label}`;
  }
}
